import { InAppTemplate } from "../../../shared/templates/inapp";
import { PushSettingsControl } from "../../../shared/components/push/PushNotifications";

const NotificationSettings = () => <InAppTemplate childComponent={
  <div className="inapp-content"><div className="page-content cards setting-page">
    <div className="page-heading"><h3>Notification settings</h3></div>
    <PushSettingsControl />
  </div></div>
} />;

export default NotificationSettings;
